import React from 'react';
import LeagueFilterComponent from './leagueFilterComponent';
import RatingFilterComponent from './ratingFilterComponent';
import YearFilterComponent from './yearFilterComponent';
import ClubFilterComponent from './clubFilterComponent';

const styles: any = {
  root: {
    display: 'flex',
    gap: '10px',
    marginLeft: '5px',
    justifyContent: 'space-between',
    marginRight: '25px',
  },
};

const LicenceAnalyticsFiltersWrapper: React.FC = () => {
  return (
    <div className="filtersWrapperRoot" style={styles.root}>
      <LeagueFilterComponent />
      <RatingFilterComponent />
      <YearFilterComponent />
      <ClubFilterComponent />
    </div>
  );
};

export default LicenceAnalyticsFiltersWrapper;
